import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { ProjectContext } from "../../App";
import { SiConvertio } from "react-icons/si";
import "../../styles/projects/Estimation.css";
import "../../styles/projects/UpdatePhases.css";
import { useAuth } from "../Authentication/AuthContext";
import { useRolePermissions } from "../Settings/RoleContext";
import api from "../../api/axiosConfig";
import { GrHide } from "react-icons/gr";
import { IoMdClose } from "react-icons/io";
import { PiColumnsPlusRight } from "react-icons/pi";
import ConvertToProject from "./ConvertToProject";
import { FaChevronDown } from "react-icons/fa";
import EditIcon from "@mui/icons-material/Edit";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TiPinOutline } from "react-icons/ti";
import { TiPin } from "react-icons/ti";
import { ToastContainer, toast } from "react-toastify";
import socket from "../../socket";
import AddCustomer from "../DialBox/AddCustomerDial";
import { MultiSelect } from "react-multi-select-component";

import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardArrowLeft,
  MdKeyboardDoubleArrowRight,
  MdKeyboardArrowRight,
} from "react-icons/md";

export const Estimation = () => {
  const { hasPermission } = useRolePermissions();
  const { isNavBarOpen } = useContext(ProjectContext);
  const { userDetails } = useAuth();
  const tableRef = useRef(null);
  const userID = userDetails.id;
  const [users, setUsers] = useState([]);
  const [selectedOwnwer, setSelectedOwner] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedContact, setSelectedContact] = useState("");
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");
  const [estimates, setEstimates] = useState([]); // State to hold fetched estimates
  const [updatedProject, setUpdatedProject] = useState(null);
  const [estEditable, setEstEditable] = useState(false);
  const [estimateToDelete, setEstimateToDelete] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState("");
  const [statuses, setStatuses] = useState({}); // Store status for each estimate by ID
  const [openDialog, setOpenDialog] = useState(false);
  useEffect(() => {
    if (selectedCustomer) {
      const customer = customers.find((c) => c.id === Number(selectedCustomer));
      const name = `${customer.customerno}-${customer.name}`;
      setSelectedCustomerName(name);
    }
  }, [selectedCustomer, customers]);
  // Initialize statuses when estimates are received
  useEffect(() => {
    const initialStatuses = estimates.reduce((acc, estimate) => {
      acc[estimate.id] = estimate.status; // Set initial status based on estimates
      return acc;
    }, {});
    setStatuses(initialStatuses);
  }, [estimates]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [isConvertDialogOpen, setIsConvertDialogOpen] = useState(false);
  const [selectedEstimateDetails, setSelectedEstimateDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [projectsPerPage, setProjectsPerPage] = useState(() => {
    return Number(localStorage.getItem("estimatePerPage")) || 25;
  });

  useEffect(() => {
    localStorage.setItem("estimatePerPage", projectsPerPage.toString());
  }, [projectsPerPage]);
  const calculatePaginationCount = (projectsPerPage, currentPage) => {
    const start = (currentPage - 1) * projectsPerPage + 1;
    const end = start + projectsPerPage - 1;
    return `${start}-${end}`;
  };
  const paginationCount = calculatePaginationCount(
    projectsPerPage,
    currentPage
  );
  const [isEstDialogOpen, setIsEstDialogOpen] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  // Form States
  const [estimationno, setEstimationno] = useState("");
  const [edate, setEdate] = useState("");
  const [projectname, setProjectname] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  // Updating Phases for Estimates
  const tableHeading = [
    "Date",
    "Estimate",
    "MSES No",
    "Project",
    "Customer",
    "Contact",
    "Sales",
    "Estimate (DE)",
    "Estimate (DO)",
    "DE PHrs",
    "DO PHrs",
    "Status",
    "Completed",
    "Convert Status",
    "Remarks",
  ];
  const [visibleColumns, setVisibleColumns] = useState({
    Date: true,
    Estimate: true,
    "MSES No": true,
    Project: true,
    Customer: true,
    Contact: true,
    Sales: true,
    "Estimate (DE)": true,
    "Estimate (DO)": true,
    "DE PHrs": true,
    "DO PHrs": true,
    Status: true,
    Completed: true,
    "Convert Status": true,
    Remarks: true,
  });
  const [columns, setColumns] = useState(tableHeading);
  const projectRef = useRef(null);
  const [columnWidths, setColumnWidths] = useState(Array(13).fill(100));
  const [filter, setFilter] = useState("");
  const [groupBy, setGroupBy] = useState("");
  const startX = useRef(null);
  const startWidth = useRef(null);
  const activeColumnIndex = useRef(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [draggedColumnIndex, setDraggedColumnIndex] = useState(null);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    column: null,
  });
  const [stickyColumns, setStickyColumns] = useState(() => {
    const storedColumns = localStorage.getItem("estimatestickyColumns");
    return storedColumns ? JSON.parse(storedColumns) : ["Date"];
  });
  useEffect(() => {
    // Store the stickyColumns in localStorage whenever it updates
    localStorage.setItem(
      "estimatestickyColumns",
      JSON.stringify(stickyColumns)
    );
  }, [stickyColumns]);

  const toggleStickyColumn = (heading) => {
    setStickyColumns((prev) => {
      if (prev.length === 1 && prev.includes(heading)) return prev;

      const updatedColumns = prev.includes(heading)
        ? prev.filter((col) => col !== heading) // Remove from sticky
        : [...prev, heading]; // Add to sticky

      return updatedColumns;
    });
  };

  const updateColumnPositions = (stickyCols = stickyColumns) => {
    if (!tableRef.current) return;

    const table = tableRef.current;
    const thead = table.querySelector("thead");

    if (thead) {
      thead.style.position = "sticky";
      thead.style.top = "-1px";
      thead.style.zIndex = "5";
      thead.style.backgroundColor = "white";
      thead.style.borderBottom = "1px solid #9d9d9d";
    }

    const headers = table.querySelectorAll("th");
    const rows = table.querySelectorAll("tr");

    let leftOffset = 0; // Start position for sticky columns
    const lastColumnIndex = headers.length - 2; // Exclude last column (assuming it has no header)

    headers.forEach((header, index) => {
      const colName = header.innerText.trim();

      if (
        (stickyCols.includes(colName) || index === 0) &&
        index < lastColumnIndex
      ) {
        // ✅ Sticky columns (excluding last column)
        header.style.position = "sticky";
        header.style.left = `${leftOffset}px`;
        header.style.zIndex = "4";
        header.style.backgroundColor = "white";

        leftOffset += header.offsetWidth; // Move to next column position
      } else if (index < lastColumnIndex) {
        // ✅ Reset styles when unpinned (excluding last column)
        header.style.position = "";
        header.style.left = "";
        header.style.zIndex = "";
        header.style.backgroundColor = "";
        header.style.borderBottom = "";
        header.style.borderTop = "";
      }
    });

    rows.forEach((row) => {
      const cells = row.querySelectorAll("td");

      leftOffset = 0; // Reset for row

      cells.forEach((cell, index) => {
        const colName = headers[index]?.innerText.trim();

        if (
          (stickyCols.includes(colName) || index === 0) &&
          index <= lastColumnIndex
        ) {
          // ✅ Sticky columns (except last functional column)
          cell.style.position = "sticky";
          cell.style.left = `${leftOffset}px`;
          cell.style.zIndex = "2";
          cell.style.backgroundColor = "inherit";
          cell.style.borderBottom = "none";
          cell.style.borderTop = "1px solid #9d9d9d";
          leftOffset += cell.offsetWidth; // Align next sticky column
        } else {
          // ✅ Reset styles when unpinned
          cell.style.position = "";
          cell.style.left = "";
          cell.style.zIndex = "";
          cell.style.backgroundColor = "";
          cell.style.borderBottom = "";
          cell.style.borderTop = "";
        }
      });
    });
  };

  useEffect(() => {
    setTimeout(() => {
      updateColumnPositions(stickyColumns);
    }, 1000);
  }, [stickyColumns, isNavBarOpen, groupBy, estimates, currentPage, filter]);

  useEffect(() => {
    socket.on("newcustomer added", (newCustomer) => {
      setCustomers((prev) => [...prev, newCustomer]);
    });
    socket.on("newContact added", (newCustomer) => {
      setContacts((prev) => [...prev, newCustomer]);
    });

    socket.on("estimate updated", (updatedEstimate) => {
      const fetchNewData = async () => {
        try {
          // Fetch updated estimates
          const [estimatesRes] = await Promise.all([api.get("/api/estimates")]);

          // Find the updated estimate
          const newlyEditedEstimate = estimatesRes.data.estimates.find(
            (est) => est.id === Number(updatedEstimate.id)
          );

          if (!newlyEditedEstimate) return; // Ensure the estimate exists

          setEstimates((prevEstimates) =>
            prevEstimates.map((est) =>
              est.id === Number(newlyEditedEstimate.id)
                ? newlyEditedEstimate
                : est
            )
          );
        } catch (error) {
          handleApiError(error);
        }
      };

      if (updatedEstimate) {
        fetchNewData();
      }
    });

    socket.on("estimate added", (newEstimate) => {
      const fetchNewData = async () => {
        try {
          // Fetch updated estimates
          const estUrl =
            userDetails.role_name === "Administrator" ||
            userDetails.role_name === "Super Admin"
              ? "/api/estimates"
              : `/api/estimates/${userDetails.id}`;
          const [estimatesRes] = await Promise.all([api.get(estUrl)]);

          // Find the newly added estimate
          const newlyAddedEstimate = estimatesRes.data.estimates.find(
            (est) => est.id === Number(newEstimate.newEstimate.id)
          );

          if (newlyAddedEstimate) {
            setEstimates((prev) => [...prev, newlyAddedEstimate]);
          }
        } catch (error) {
          handleApiError(error);
        }
      };

      if (newEstimate) {
        fetchNewData();
      }
    });

    socket.on("estimate status updated", (estimateId, status) => {
      setEstimates((prevEstimates) =>
        prevEstimates.map((est) =>
          est.id === Number(estimateId) ? { ...est, status: status } : est
        )
      );
    });

    socket.on("estimate deleted", (ids) => {
      // Extract the array correctly
      const idsArray = Array.isArray(ids?.ids) ? ids.ids : [];

      setEstimates((prevProjects) =>
        prevProjects.filter((est) => !idsArray.includes(est.id))
      );
    });

    return () => {
      socket.off("newcustomer added");
      socket.off("newContact added");
      socket.off("estimate added");
      socket.off("estimate deleted");
      socket.off("estimate updated");
      socket.off("estimate status updated");
    };
  }, []);

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedCustomerName("");
    // setUpdatedProject({ ...estimate, customer_name: "" });
    const filtered = customers.filter((customer) => {
      const name = customer.name || ""; // Fallback to an empty string
      const no = customer.customerno || ""; // Fallback to an empty string
      const displayName = customer.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        no.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredCustomers(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };

  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredCustomers(customers); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };

  const toggleFormVisibility = () => {
    setIsFormVisible((prevState) => !prevState);
    updateColumnPositions(stickyColumns);
  };
  const saveUserPreferences = async (preferences) => {
    const userId = userID; // Replace with the actual logged-in user's ID

    try {
      const response = await api.post(
        "/api/estimates/save-column-preferences",
        {
          userId,
          preferences,
        }
      );
    } catch (error) {
      console.error("Error saving preferences:", error);
    }
  };
  //function for column visibility
  const toggleColumnVisibility = (columnKey) => {
    const updatedVisibleColumns = {
      ...visibleColumns,
      [columnKey]: !visibleColumns[columnKey],
    };

    // Update the state with the new visibility
    setVisibleColumns(updatedVisibleColumns);

    // Call the API to save the updated preferences
    saveUserPreferences(updatedVisibleColumns);
  };

  const handleRightClick = (event, column) => {
    event.preventDefault();
    setContextMenu({
      visible: true,
      x: event.clientX,
      y: event.clientY,
      column: column,
    });
  };

  const handleDragStart = (index) => {
    setDraggedColumnIndex(index);
  };

  const handleDrop = (dropIndex) => {
    if (draggedColumnIndex !== null) {
      // Clone columns array and reorder it
      const updatedColumns = [...columns];
      const [draggedColumn] = updatedColumns.splice(draggedColumnIndex, 1);
      updatedColumns.splice(dropIndex, 0, draggedColumn);

      // Update the columns in state
      setColumns(updatedColumns);

      // Update visibility order to match the new column order
      const newVisibleColumns = {};
      updatedColumns.forEach((col) => {
        newVisibleColumns[col] = visibleColumns[col];
      });
      setVisibleColumns(newVisibleColumns);

      // Save preferences to persist updated order and visibility
      saveUserPreferences(newVisibleColumns);

      // Reset draggedColumnIndex
      setDraggedColumnIndex(null);
    }
  };

  const hideColumn = async () => {
    if (contextMenu.column) {
      const updatedColumns = {
        ...visibleColumns,
        [contextMenu.column]: false,
      };
      setVisibleColumns(updatedColumns);
      setContextMenu({ ...contextMenu, visible: false });
      saveUserPreferences(updatedColumns);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the context menu
      if (projectRef.current && !projectRef.current.contains(event.target)) {
        setContextMenu({ ...contextMenu, visible: false });
      }
    }; // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [contextMenu]);

  const handleConvert = async (estimateId) => {
    try {
      const response = await api.get(`/api/estimates/${estimateId}/details`);
      const estimateDetails = response.data;
      setSelectedEstimateDetails(estimateDetails);
      setIsConvertDialogOpen(true);
    } catch (error) {
      console.error("Error fetching estimate details:", error);
    }
  };

  // useEffect operations
  const fetchUserPreferences = async (userID) => {
    try {
      const response = await api.get(
        `/api/estimates/get-column-preferences/${userID}`
      );
      return response.data; // Axios automatically parses JSON responses
    } catch (error) {
      console.error("Error fetching preferences:", error);
      return null;
    }
  };

  useEffect(() => {
    // Fetch the user preferences when the component mounts
    const loadPreferences = async () => {
      const preferences = await fetchUserPreferences(userID);
      if (preferences) {
        setVisibleColumns(preferences);
        setColumns(Object.keys(preferences));
      } else {
        // Set default preferences if no saved preferences found
        const defaultColumns = {
          // delete: true,
          Date: true,
          Estimate: true,
          "MSES No": true,
          Project: true,
          Contact: true,
          Sales: true,
          Customer: true,
          "DE PHrs": true,
          "Estimate (DE)": true,
          "DO PHrs": true,
          "Estimate (DO)": true,
          Status: true,
          Completed: true,
          "Convert Status": true,
          Remarks: true,
        };
        setVisibleColumns(defaultColumns);
        setColumns(Object.keys(defaultColumns));
      }
    };

    loadPreferences();
  }, [userID]);
  const handleMouseMove = (e) => {
    if (activeColumnIndex.current !== null) {
      let newWidth = startWidth.current + (e.pageX - startX.current);
      newWidth = Math.max(50, Math.min(newWidth, 500)); // Use reasonable limits
      setColumnWidths((prevWidths) => {
        const updatedWidths = [...prevWidths];
        updatedWidths[activeColumnIndex.current] = newWidth;
        return updatedWidths;
      });
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    activeColumnIndex.current = null;
  };
  const handleMouseDown = (index, e) => {
    startX.current = e.pageX;
    startWidth.current = columnWidths[index];
    activeColumnIndex.current = index;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const fetchInitialData = async () => {
    setLoading(true);
    try {
      // Fetch other data in parallel
      const estUrl =
        userDetails.role_name === "Administrator" ||
        userDetails.role_name === "Super Admin"
          ? "/api/estimates"
          : `/api/estimates/${userDetails.id}`;
      const [customerRes, statusRes, estimatesRes, userRes] = await Promise.all(
        [
          api.get("/api/customers"),
          api.get("/api/get-status-values"),
          api.get(estUrl),
          api.get("/api/users"),
        ]
      );
      setUsers(userRes.data);
      setCustomers(customerRes.data);
      setLoading(false);
      setStatus(statusRes.data);
      setEstimates(estimatesRes.data.estimates);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, [userDetails]);

  // Helper to handle API errors
  const handleApiError = (error) => {
    if (error.response) {
      console.error(
        "Server Error:",
        error.response.data.error || error.response.statusText
      );
      setErrorMessage(
        `Server Error: ${
          error.response.data.error || error.response.statusText
        }`
      );
    } else if (error.request) {
      console.error("No response received:", error.request);
      setErrorMessage("No response received from the server.");
    } else {
      console.error("Request Error:", error.message);
      setErrorMessage(`Request Error: ${error.message}`);
    }
  };

  // Fetch contacts based on selected customer
  const handleCustomerChange = useCallback(async (e) => {
    const selectedCustomerId = e.target.value;
    setSelectedCustomer(selectedCustomerId);
    setShowDropdown(false);
    setSearchTerm("");
    setSelectedContact(""); // Reset contact selection

    try {
      const { data } = await api.get(
        `/api/customers/${selectedCustomerId}/contacts`
      );
      setContacts(data.contacts);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setContacts([]);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: estimationno and edate are required
    if (!estimationno.trim() || !edate) {
      setErrorMessage("Estimation number and date are required.");
      return;
    }
    const created_by = userDetails.id;

    const requestData = {
      estimationno,
      edate,
      projectname,
      customer_id: selectedCustomer,
      contact_id: selectedContact,
      sales_person: selectedSalesPerson,
      description,
      created_by,
      selectedOwnwer,
    };

    try {
      const response2 = await api.post("/api/estimates_info", requestData);
      navigate(`/estimate/phases/${response2.data.estimateId}`);
      resetForm();
      setIsEstDialogOpen(false);
    } catch (error) {
      console.error("Error creating estimate:", error);

      // Extract backend error message
      const serverMessage = error.response?.data?.error;

      // Set local error message state
      setErrorMessage(serverMessage || "Failed to create estimation");

      // ❌ Don't close dialog if validation error
      const knownValidationErrors = [
        "Estimate number already exists. Contact DC for further information.",
        "Project name already exists. Contact DC for further information.",
      ];

      if (!knownValidationErrors.includes(serverMessage)) {
        setIsEstDialogOpen(false);
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    // Validation for estimation number and date
    if (!estimationno.trim() || !edate) {
      setErrorMessage("Estimation number and date are required");
      return;
    }

    // Prepare request payload
    const requestData = {
      estimationno, // Estimation number
      date: edate, // Date
      projectname, // Project name
      customer_id: selectedCustomer, // Customer ID
      contact_id: selectedContact, // Contact ID
      sales_person: selectedSalesPerson,
      selectedOwnwer,
    };

    try {
      const response = await api.put(
        `/api/update-estimates_info/${updatedProject.id}`,
        requestData
      );
      setEstEditable(false);

      // Update state with the newly updated estimate
      setEstimates((prevEstimates) => {
        // Find the updated estimate in the array and update it
        const updatedEstimates = prevEstimates.map((estimate) =>
          estimate.estimationno === updatedProject.estimationno
            ? { ...estimate, ...response.data }
            : estimate
        );
        return updatedEstimates;
      });
      // Reset the form and close the dialog
      resetForm();
      setIsEstDialogOpen(false);
    } catch (error) {
      console.error("Error updating estimate:", error); // Debugging log
      setErrorMessage(
        error.response?.data?.error || "Failed to update estimation"
      );
    } finally {
      setIsEstDialogOpen(false);
    }
  };

  const fetchNextEstimateNo = async () => {
    const res = await api.get("/api/estimates");
    // Extract all numeric parts from estimation numbers
    const estimateNumbers = res.data.estimates
      .map((est) => {
        const match = est.estimationno?.match(/^E(\d+)$/);
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((num) => num !== null);

    // Find the highest number
    const maxNumber =
      estimateNumbers.length > 0 ? Math.max(...estimateNumbers) : 1000;

    // Generate next estimate number
    const nextEstNumber = `E${(maxNumber + 1).toString().padStart(4, "0")}`;

    setEstimationno(nextEstNumber);
  };

  const handleEstOpenDialog = () => {
    setIsEstDialogOpen(true);
    fetchNextEstimateNo();
  };

  const handleEstCloseDialog = () => {
    setIsEstDialogOpen(false);
    setEstEditable(false);
    resetForm();
  };
  const resetForm = () => {
    setEdate("");
    setSelectedCustomer("");
    setSelectedContact("");
    setEstimationno("");
    setProjectname("");
    setDescription("");
    setErrorMessage("");
    setSelectedCustomerName("");
    setSelectedOwner([]);
    setSelectedSalesPerson("");
  };

  const handleDeleteProject = (e, selectedEstimate) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setEstimateToDelete((prevSelected) => [
        ...prevSelected,
        selectedEstimate,
      ]);
    } else {
      setEstimateToDelete((prevSelected) =>
        prevSelected.filter((project) => project.id !== selectedEstimate.id)
      );
    }
  };

  const handleDeleteConfirm = async () => {
    setLoading(true);
    const idsToDelete = estimateToDelete.map((project) => project.id);

    setDeleteDialogOpen(false); // Close the delete confirmation dialog

    try {
      const response = await api.delete("/api/estimates", {
        data: { ids: idsToDelete }, // Send the IDs in the request body
      });

      // Check for successful deletion
      if (response.status === 204) {
        const updatedEstimate = estimates.filter(
          (project) => !idsToDelete.includes(project.id)
        );
        setEstimates(updatedEstimate); // Update the projects state
        setLoading(false);
      } else {
        console.error("Failed to delete projects");
        toast.error("Failed to delete estimate. Please try again.", {
          position: "bottom-center",
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("There was an error deleting the projects:", error);
      toast.error(
        "An error occurred while deleting estimate. Please try again.",
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );
    } finally {
      setEstimateToDelete([]); // Clear the projects to delete
      handleCloseDial(); // Close any dialog
      setLoading(false);
    }
  };

  const handleCloseDial = () => {
    setIsCheckboxChecked(false);
    setDeleteDialogOpen(false);
  };
  const mapKeyToProjectProperty = (heading) => {
    switch (
      heading.trim() // Use trim() to remove any accidental spaces
    ) {
      case "Estimate":
        return "estimationno";
      case "MSES No":
        return "msesno"; // Ensure this matches the exact key in your project data
      case "Project":
        return "projectname";
      case "Customer":
        return "customer_name";
      case "Contact":
        return "contact_name";
      case "Sales":
        return "sales_person_name";
      case "Date":
        return "edate";
      case "Status":
        return "status";
      case "Estimate (DE)":
        return "estimated_by_design";
      case "Estimate (DO)":
        return "estimated_by_detailing";
      case "DE PHrs":
        return "des-phrs";
      case "DO PHrs":
        return "det-phrs";
      case "Completed":
        return "completed_total";
      case "Convert Status":
        return "converted_by_name";
      case "Remarks":
        return "description";
      case "S.No":
        return "index";
      default:
        return "";
    }
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const sortedEstimates = [...estimates].sort((a, b) => {
    if (!sortConfig?.key) {
      const getNumericPart = (value) => {
        if (typeof value !== "string") return 0;
        return parseInt(value.replace(/\D/g, ""), 10) || 0;
      };

      const bValue = getNumericPart(b.estimationno || ""); // Use an empty string if undefined
      const aValue = getNumericPart(a.estimationno || ""); // Use an empty string if undefined

      return bValue - aValue;
    }

    const { key, direction } = sortConfig;
    const sortDirection = direction === "asc" ? 1 : -1;

    let aValue = a[key];
    let bValue = b[key];

    // Handle specific sorting cases
    switch (key) {
      case "estimationno":
      case "msesno":
        const getNumericPart = (value) => {
          if (typeof value !== "string") return 0;
          return parseInt(value.replace(/\D/g, ""), 10) || 0;
        };
        getNumericPart(undefined); // Returns 0 safely
        aValue = getNumericPart(aValue);
        bValue = getNumericPart(bValue);
        break;

      case "date":
        aValue = new Date(aValue);
        bValue = new Date(bValue);
        break;

      case "projectname":
      case "status":
      case "user_name":
      case "customer_name":
      case "contact_name":
      case "description":
      case "remarks":
      case "estimated_by_design":
      case "estimated_by_detailing":
      case "sales_person__name":
        aValue = String(aValue || "").toLowerCase();
        bValue = String(bValue || "").toLowerCase();
        break;

      default:
        if (typeof aValue === "string") aValue = aValue.toLowerCase();
        if (typeof bValue === "string") bValue = bValue.toLowerCase();
        break;
    }

    // Perform sorting
    if (aValue < bValue) return -1 * sortDirection;
    if (aValue > bValue) return 1 * sortDirection;
    return 0;
  });

  const filteredEstimates = sortedEstimates.filter((estimate) => {
    return (
      estimate.msesno?.toLowerCase().includes(filter) ||
      estimate.estimationno?.toLowerCase().includes(filter) ||
      estimate.projectname?.toLowerCase().includes(filter) ||
      estimate.customer_name?.toLowerCase().includes(filter) ||
      estimate.contact_name?.toLowerCase().includes(filter) ||
      estimate.status?.toLowerCase().includes(filter)
    );
  });

  const handleSearch = (e) => {
    setFilter(e.target.value.toLowerCase());
  };

  const totalPages = Math.ceil(filteredEstimates.length / projectsPerPage);

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const groupProjects = (projects) => {
    if (!groupBy) return null;

    const grouped = {};

    projects.forEach((p) => {
      let key = "";
      switch (groupBy) {
        case "Customer":
          key = p.customer_name || "Unknown";
          break;
        case "Status":
          key = p.status || "Unknown";
          break;
        case "Manager":
          key = p.project_manager_name || "Unknown";
          break;
        case "Date":
          key = p.edate || null;
          break;
        case "Converted":
          key = p.converted_by_name || "Not Converted";
          break;
        case "Estimated":
          key =
            p.estimated_by_detailing ||
            p.estimated_by_design ||
            "Not Estimated";
          break;
      }

      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(p);
    });

    // Return sorted entries
    return Object.entries(grouped)
      .sort(([a], [b]) => a.localeCompare(b))
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  };

  const allGroupedProjects =
    groupBy !== "All Projects"
      ? groupProjects(filteredEstimates, groupBy)
      : null;

  // Flatten grouped projects if grouping is applied
  const flattenedProjects = allGroupedProjects
    ? Object.values(allGroupedProjects).flat()
    : filteredEstimates;
  const currentProjects = flattenedProjects.slice(
    indexOfFirstProject,
    indexOfLastProject
  );

  const handleStatusChange = async (e, estimateId) => {
    const newStatus = e.target.value;
    const isConfirmed = window.confirm(
      "Are you sure you want to change the estimate status?"
    );

    if (!isConfirmed) {
      // If the user clicks "Cancel", do nothing and return
      return;
    }
    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [estimateId]: newStatus, // Update the status of the selected estimate
    }));

    // Update status in the backend
    try {
      const response = await api.put("/api/update-estimate-status", {
        estimateId,
        status: newStatus, // Send estimateId and new status
      });
      // fetchInitialData();
      if (!response.ok) {
        throw new Error("Failed to update status");
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // Handlers for pagination
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleFirstPage = () => {
    if (currentPage > 1) setCurrentPage(1);
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) setCurrentPage(totalPages);
  };

  const handleEditClick = async (estimate) => {
    setSelectedOwner(estimate.estimate_owner);
    setSelectedCustomer(estimate.customer_id);
    setSelectedContact(estimate.contact_id);
    setSelectedSalesPerson(estimate.sales_person);
    setUpdatedProject({ ...estimate });
    setEstimationno(estimate.estimationno);
    setEdate(estimate.edate);
    setProjectname(estimate.projectname);
    setEstEditable(true);
    setIsEstDialogOpen(true);
    if (estimate.customer_id) {
      try {
        const { data } = await api.get(
          `/api/customers/${estimate.customer_id}/contacts`
        );
        setContacts(data.contacts);
      } catch (error) {
        console.error("Error fetching contacts:", error);
        setContacts([]);
      }
    }
  };

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );
  }
  const ChangeEstimateDetails = (estimateId, columnToUpdate, newValue) => {
    // Update the specific column value for the estimate
    setEstimates((prevEstimates) => {
      return prevEstimates.map((est) =>
        est.id === estimateId
          ? { ...est, [columnToUpdate]: newValue } // Dynamically update the column
          : est
      );
    });
  };

  const UpdateDetails = async (estimateId, columnToUpdate, newValue) => {
    try {
      const response = await api.put("/api/update-estimate", {
        estimateId,
        columnToUpdate,
        newValue, // Include any necessary data
      });
      if (response.ok) {
        console.log("Details updated successfully");
      } else {
        throw new Error("Failed to update details");
      }
    } catch (error) {
      console.error("Error updating details:", error);
    }
  };

  const renderRowData = (estimate) => {
    return columns.map((columnKey) => {
      if (visibleColumns[columnKey]) {
        switch (columnKey) {
          case "Date":
            return (
              <td style={{ minWidth: "90px" }} key="edate">
                {estimate.edate
                  ? format(new Date(estimate.edate), "dd-MM-yyyy")
                  : ""}
              </td>
            );
          case "MSES No":
            return (
              <td style={{ padding: "0px" }} key="msesno">
                <input
                  className="est-description"
                  maxLength={20}
                  value={estimate.msesno}
                  onChange={(e) =>
                    ChangeEstimateDetails(estimate.id, "msesno", e.target.value)
                  }
                  onBlur={(e) => {
                    UpdateDetails(estimate.id, "msesno", e.target.value);
                  }}
                />
              </td>
            );
          case "Estimate":
            return (
              <td>
                <div className="estimate-table-con" key="estimationno">
                  <Link
                    className="select-project"
                    style={{
                      marginTop: "5px",
                      fontSize: "12.5px",
                    }}
                    to={`/estimate/phases/${estimate.id}`}
                  >
                    {estimate.estimationno}
                  </Link>
                  {hasPermission("estimates", "update") && (
                    <span className="edit-icon-wrapper" title="Edit project">
                      <EditIcon
                        onClick={() => handleEditClick(estimate)}
                        style={{
                          backgroundColor: "transparent",
                          color: "blue",
                        }}
                      />
                    </span>
                  )}
                </div>
              </td>
            );
          case "Project":
            return (
              <td style={{ paddingRight: "5px" }} key="projectname">
                {estimate.projectname}
              </td>
            );
          case "Customer":
            return (
              <td style={{ paddingRight: "5px" }} key="customer_name">
                {estimate.customer_name}
              </td>
            );
          case "Contact":
            return <td key="contact_name">{estimate.contact_name}</td>;
          case "Sales":
            return (
              <td key="sales_person__name">{estimate.sales_person_name}</td>
            );
          case "Status":
            return (
              <td
                className={`estimate-status-dropdown-con ${
                  statuses[estimate.id] || ""
                }`}
                title={
                  estimate.status === "Awarded" && estimate.awarded_at
                    ? format(estimate.awarded_at, "dd-MM-yyyy")
                    : ""
                }
                key="status"
              >
                <select
                  className={`estimate-status-dropdown ${
                    statuses[estimate.id] || ""
                  }`}
                  value={statuses[estimate.id] || ""}
                  onChange={(e) => handleStatusChange(e, estimate.id)}
                  disabled={
                    !hasPermission("estimates", "update") ||
                    (estimate.status === "Awarded" &&
                      userDetails.role_name !== "Super Admin")
                  }
                >
                  <option value="" disabled>
                    Select Status
                  </option>
                  {Object.entries(status).map(([key, value]) => (
                    <option key={key} value={value}>
                      {value}
                    </option>
                  ))}
                </select>
              </td>
            );
          case "Estimate (DE)":
            return (
              <td key="estimated_by_design">
                {estimate.estimated_by_design
                  ? estimate.estimated_by_design
                  : ""}
              </td>
            );
          case "Estimate (DO)":
            return (
              <td key="estimated_by_detailing">
                {estimate.estimated_by_detailing
                  ? estimate.estimated_by_detailing
                  : ""}
              </td>
            );
          case "DE PHrs":
            return (
              <td style={{ textAlign: "center" }} key="des-phrs">
                {estimate.template_planned_hours
                  .filter((template) => template.template_name === "Design")
                  .map((template) =>
                    template.planned_hours.substring(0, 5) === "00:00"
                      ? ""
                      : template.planned_hours
                  )
                  .join(", ")}
              </td>
            );
          case "DO PHrs":
            return (
              <td style={{ textAlign: "center" }} key="det-phrs">
                {estimate.template_planned_hours
                  .filter((template) => template.template_name === "Detailing")
                  .map((template) =>
                    template.planned_hours.substring(0, 5) === "00:00"
                      ? ""
                      : template.planned_hours
                  )
                  .join(", ")}
              </td>
            );
          case "Completed":
            return (
              <td key="completed_total">
                {estimate.completed_total !== "0 out of 0" &&
                  estimate.completed_total}
              </td>
            );
          case "Convert Status":
            return (
              <td
                key="converted_by_name"
                className="convert-column"
                style={{
                  padding: "0px",
                  position: "relative",
                  textAlign: "left",
                }}
              >
                {estimate.converted_by === null
                  ? estimate.template_planned_hours.length === 0 ||
                    estimate.template_planned_hours.some(
                      (template) => template.planned_hours === null
                    )
                    ? "No Tasks available"
                    : statuses[estimate.id] === "Awarded" && (
                        <button
                          disabled={!hasPermission("estimates", "update")}
                          className="convert-btn"
                          onClick={() => handleConvert(estimate.id)}
                        >
                          <SiConvertio />
                        </button>
                      )
                  : estimate.converted_by_name}
              </td>
            );
          case "Remarks":
            return (
              <td style={{ padding: "0px" }} key="description">
                <textarea
                  className="est-remarks-description"
                  maxLength={100}
                  onChange={(e) =>
                    ChangeEstimateDetails(
                      estimate.id,
                      "description",
                      e.target.value
                    )
                  }
                  onBlur={(e) =>
                    UpdateDetails(estimate.id, "description", e.target.value)
                  }
                  value={estimate.description}
                />
              </td>
            );
        }
      }
    });
  };

  const isAllSelected = () => {
    return Object.keys(visibleColumns).every(
      (heading) =>
        heading === "Estimate" ||
        heading === "MSES No" ||
        heading === "Date" ||
        heading === "Project" ||
        visibleColumns[heading]
    );
  };

  const groupedProjects = groupProjects(currentProjects);

  return (
    <>
      {isEstDialogOpen && (
        <div className="timesheet-overlay-add-time-log">
          <div className="create-est-con">
            <div className="new-estimation-log">
              <h3 className="add-estimation-heading">
                {estEditable ? "Edit Estimate" : "Create Estimate"}
              </h3>
            </div>
            <div className="scrollable-e-content">
              <form
                id="estimation-form"
                onSubmit={estEditable ? handleUpdate : handleSubmit}
              >
                <div>
                  <h3 className="user-name">Date</h3>
                  <DatePicker
                    placeholderText="Select Date"
                    className="timesheet-d-input"
                    selected={edate}
                    onChange={(date) => setEdate(date)}
                    dateFormat="dd-MM-yyyy"
                    required
                  />
                </div>
                <div>
                  <h3 className="user-name">Estimate No</h3>
                  <input
                    className="timesheet-d-input"
                    placeholder="Enter Estimate No"
                    type="text"
                    maxLength={20}
                    value={estimationno || ""}
                    onChange={(e) => setEstimationno(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <h3 className="user-name">Project</h3>
                  <input
                    className="timesheet-d-input"
                    placeholder="Enter Project Name"
                    type="text"
                    maxLength={50}
                    value={projectname || ""}
                    onChange={(e) => setProjectname(e.target.value)}
                    required
                  />
                </div>
                <div></div>
                <div>
                  <h3 className="user-name">Customer</h3>
                  <input
                    ref={dropdownRef}
                    className="timesheet-d-input"
                    placeholder="Search Customer"
                    value={
                      searchTerm !== null
                        ? searchTerm || selectedCustomerName
                        : ""
                    }
                    onChange={handleSearchChange}
                    onFocus={handleFocus}
                    onMouseDown={() => handleClickOutside}
                  />
                  {showDropdown &&
                    (showDropdown && filteredCustomers?.length > 0 ? (
                      <ul
                        style={{ zIndex: "50" }}
                        ref={dropdownRef}
                        className="project-display-box"
                      >
                        {filteredCustomers.map((project) => (
                          <li
                            key={project.id}
                            value={project.id}
                            onClick={(e) => handleCustomerChange(e)}
                            onMouseDown={() => handleClickOutside}
                            className="project-dropdown-item"
                          >
                            {project.customerno}-{project.name}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <>
                        <p>Customer not available</p>
                        <button
                          className="add-est-cus-btn"
                          onClick={() => setOpenDialog(true)}
                        >
                          Add Customer
                        </button>
                      </>
                    ))}
                </div>
                <div style={{ marginBottom: "7px" }}>
                  <h3 className="user-name">Contact</h3>
                  <select
                    className="timesheet-input"
                    value={selectedContact}
                    onChange={(e) => setSelectedContact(e.target.value)}
                    required
                  >
                    <option value="" disabled>
                      Select Contact
                    </option>
                    {contacts.map((contact) => (
                      <option
                        key={contact.contact_id}
                        value={contact.contact_id}
                      >
                        {contact.contact_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  Sales Person
                  <select
                    className="timesheet-input"
                    value={selectedSalesPerson}
                    onChange={(e) => setSelectedSalesPerson(e.target.value)}
                  >
                    <option value="">Select Sales person</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <h3 className="user-name">Owner</h3>
                  <MultiSelect
                    className="est-owner"
                    value={selectedOwnwer} // ⬅️ Always pass the selected value here
                    options={users
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((user) => ({
                        label: user.name,
                        value: user.id,
                      }))}
                    onChange={(e) => {
                      setSelectedOwner(e);
                    }}
                    display="chip"
                    placeholder="Select Project Managers"
                  />
                </div>
              </form>
              {errorMessage && <div className="error">{errorMessage}</div>}
            </div>
            <div className="btn-container-add-est">
              <button
                onclick={estEditable ? handleUpdate : handleSubmit}
                form="estimation-form"
                type="submit"
                className="add-btn"
              >
                {estEditable ? "Update" : "Submit"}
              </button>
              <button onClick={handleEstCloseDialog} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {openDialog && <AddCustomer closeDial={setOpenDialog} />}

      {isFormVisible && (
        <form className="project-column-hide">
          <div className="project-column-hide-container">
            <div className="project-col-swap-header">
              <h3
                className="add-project-user-heading"
                style={{ marginLeft: "14px" }}
              >
                Add, Remove, or Swap Columns
              </h3>
            </div>
            <IoMdClose
              onClick={toggleFormVisibility}
              className="close-column-icon"
            />
            <div
              style={{ marginTop: "45px" }}
              className="project-col-header-container"
            >
              <label style={{ cursor: "pointer" }}>
                <input
                  type="checkbox"
                  // onChange={handleSelectAll}
                  onChange={() => {
                    const newState = !isAllSelected();

                    const updatedColumns = Object.keys(visibleColumns).reduce(
                      (acc, key) => {
                        // Always keep "Project No" visible
                        acc[key] = key === "MSES No" ? true : newState;
                        return acc;
                      },
                      {}
                    );

                    setVisibleColumns(updatedColumns);
                    saveUserPreferences(updatedColumns);
                  }}
                  checked={isAllSelected()}
                  style={{ marginRight: "20px", cursor: "pointer" }}
                />
                Select All
              </label>
            </div>
            {Object.keys(visibleColumns).map((heading, index) => (
              <div
                key={heading}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                className="project-col-header-container"
              >
                <label
                  style={{ cursor: "pointer" }}
                  draggable
                  onDragStart={() => handleDragStart(index)}
                  onDrop={() => handleDrop(index)}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <input
                    type="checkbox"
                    checked={visibleColumns[heading]}
                    onChange={() => toggleColumnVisibility(heading)}
                    style={{ marginRight: "20px", cursor: "pointer" }}
                  />
                  {heading}
                </label>
                {/* Pin Icon (Click to Toggle Sticky) */}
                <span
                  onClick={() => toggleStickyColumn(heading)}
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                >
                  {stickyColumns.includes(heading) ? (
                    <TiPin />
                  ) : (
                    <TiPinOutline />
                  )}
                </span>
              </div>
            ))}
          </div>
        </form>
      )}
      <div
        className={
          isNavBarOpen ? "est-table-wrapper" : "est-table-wrapper-close"
        }
      >
        <div
          className={
            isNavBarOpen ? "estimation-container" : "estimation-container-close"
          }
        >
          <input
            type="search"
            title="Search by Estimate No or Project or MSES No or Customer"
            placeholder="Search by Estimate No or Project or MSES No or Customer"
            onChange={handleSearch}
            className={isNavBarOpen ? "est-search-open" : "est-search-close"}
            value={filter}
          />
          <select
            className={isNavBarOpen ? "est-group-by" : "est-group-by-close"}
            value={groupBy}
            onChange={(e) => {
              setGroupBy(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Estimates</option>
            <option value="Customer">Customer</option>
            <option value="Status">Status</option>
            <option value="Date">Date</option>
            <option value="Converted">Converted By</option>
            {/* <option value="Estimated">Estimated By</option> */}
          </select>
          <ToastContainer />
          {/* <h3>Existing Estimates</h3> */}
          {hasPermission("estimates", "delete") &&
            estimateToDelete.length > 0 && (
              <button
                onClick={() => setDeleteDialogOpen(true)}
                className="delete-est-heading"
                title="Delete project"
              >
                Delete
              </button>
            )}

          <button onClick={handleEstOpenDialog} className="create-estimate-btn">
            Create Estimate
          </button>
          <table
            ref={tableRef}
            border="1"
            className={
              isNavBarOpen
                ? "estimation-content-table"
                : "estimation-content-table-close"
            }
          >
            <thead
              className="sticky-header-est"
              style={{ position: "sticky", top: "-1px", zIndex: "3" }}
            >
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    width: "2px",
                  }}
                >
                  <FaChevronDown />
                </th>
                {Object.keys(visibleColumns).map((heading, index) =>
                  visibleColumns[heading] ? (
                    <th
                      key={heading}
                      style={{
                        cursor: "pointer",
                        width:
                          heading === "DE PHrs" ||
                          heading === "DO PHrs" ||
                          heading === "Estimate" ||
                          heading === "Completed"
                            ? "70px" // Set 70px width for these columns
                            : heading !== "MSES No" &&
                              heading !== "Date" &&
                              heading !== "Project"
                            ? columnWidths[index] // Use the custom columnWidths for other columns
                            : "100px", // Default 100px width
                      }}
                      onClick={() =>
                        handleSort(mapKeyToProjectProperty(heading))
                      }
                      onContextMenu={
                        heading !== "MSES No" &&
                        heading !== "Estimate" &&
                        heading !== "Date" &&
                        heading !== "Project"
                          ? (e) => handleRightClick(e, heading)
                          : undefined
                      }
                    >
                      <div
                        className="resize-handle"
                        onMouseDown={(e) => handleMouseDown(index, e)}
                      />
                      {heading}
                      {sortConfig.key === mapKeyToProjectProperty(heading) && (
                        <span>
                          {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                        </span>
                      )}
                    </th>
                  ) : null
                )}
                <th
                  style={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "white",
                    boxShadow:
                      "2px 0px 5px rgba(0, 0, 0, 0.1), 2px 0px 5px rgba(0, 0, 0, 0.1)", // Left + Right shadow
                    borderCollapse: "collapse",
                    textAlign: "center",
                    padding: "5px",
                    zIndex: 2, // Ensure it appears on top
                    width: "20px",
                    borderLeft: "1px solid #9d9d9d",
                  }}
                >
                  <PiColumnsPlusRight
                    className="estimate-column-icon"
                    onClick={toggleFormVisibility}
                    title="Add Column"
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#808080",
                    }} // Optional styling for icon
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {estimates.length > 0 ? (
                groupBy && groupedProjects ? (
                  Object.entries(groupedProjects).map(([group, projects]) => (
                    <React.Fragment key={group}>
                      {/* Group Header */}
                      <tr
                        style={{
                          backgroundColor: "white",
                          fontWeight: "bold",
                          border: "1px solid #9d9d9d",
                        }}
                      >
                        <td
                          colSpan={18}
                          style={{ textAlign: "left", padding: "10px" }}
                        >
                          {groupBy === "Date"
                            ? format(group, "dd-MM-yyyy")
                            : group}
                        </td>
                      </tr>

                      {/* Grouped Project Rows */}
                      {projects.map((estimate) => (
                        <tr
                          key={estimate.id}
                          style={{
                            border: "none",
                            color: "black",
                            fontWeight: "400",
                          }}
                        >
                          <td>
                            <input
                              style={{ cursor: "pointer" }}
                              type="checkbox"
                              name={estimate.estimationno}
                              checked={estimateToDelete.some(
                                (p) => p.id === estimate.id
                              )}
                              onChange={(e) => handleDeleteProject(e, estimate)}
                              disabled={!hasPermission("estimates", "delete")}
                            />
                          </td>
                          {renderRowData(estimate)}
                          <td></td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))
                ) : (
                  currentProjects.map((estimate) => (
                    <tr key={estimate.id}>
                      <td>
                        <input
                          style={{ cursor: "pointer" }}
                          type="checkbox"
                          name={estimate.estimationno}
                          checked={estimateToDelete.some(
                            (p) => p.id === estimate.id
                          )}
                          onChange={(e) => handleDeleteProject(e, estimate)}
                          disabled={!hasPermission("estimates", "delete")}
                        />
                      </td>
                      {renderRowData(estimate)}
                    </tr>
                  ))
                )
              ) : (
                <tr>
                  <td colSpan="15" style={{ textAlign: "center" }}>
                    No estimates found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {contextMenu.visible && (
            <div
              style={{
                position: "absolute",
                top: "87px",
                left: contextMenu.x,
                backgroundColor: "white",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                padding: "8px",
                zIndex: 1000,
                display: "flex",
                flexDirection: "column",
              }}
              ref={projectRef}
            >
              <span className="hide-column-span" title="hide-column">
                <GrHide className="hide-icon" />
                <button onClick={hideColumn} className="hide-column">
                  Hide Column
                </button>
              </span>
            </div>
          )}
          <div className="estimation-pagination">
            <p>Total : {filteredEstimates.length}</p>
            <select
              className="est-list-row-count"
              value={projectsPerPage}
              onChange={(e) => {
                setProjectsPerPage(Number(e.target.value));
              }}
            >
              <option value={"25"}>25 Records Per Page</option>
              <option value={"50"}>50 Records Per Page</option>
              <option value={"75"}>75 Records Per Page</option>
              <option value={"100"}>100 Records Per Page</option>
            </select>
            <button
              className="arrow-project-btn"
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              <MdKeyboardDoubleArrowLeft title="First Page" />
            </button>
            <button
              className="arrow-project-btn"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              <MdKeyboardArrowLeft title="Previous Page" />
            </button>
            <span
              style={{
                marginTop: "3px",
                textWrap: "nowrap",
              }}
            >
              {paginationCount}
            </span>
            <button
              className="arrow-project-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              <MdKeyboardArrowRight title="Next Page" />
            </button>
            <button
              className="arrow-project-btn"
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              <MdKeyboardDoubleArrowRight title="Last Page" />
            </button>
          </div>
          {deleteDialogOpen && (
            <div className="delete-phase-dial">
              <div className="delete-dial">
                <div className="delete-header">
                  <h3
                    style={{
                      backgroundColor: "transparent",
                      marginLeft: "15px",
                      fontSize: "15px",
                    }}
                  >
                    Delete Estimate
                  </h3>
                </div>
                <div style={{ backgroundColor: "white" }}>
                  <p style={{ backgroundColor: "white" }}>
                    Are you sure you want to delete this Estimate? This action
                    cannot be undone.
                  </p>
                  <input
                    type="checkbox"
                    style={{ cursor: "pointer" }}
                    id="delete-phase"
                    checked={isCheckboxChecked}
                    onChange={() => setIsCheckboxChecked((prev) => !prev)}
                  />
                  <label
                    htmlFor="delete-phase"
                    style={{ backgroundColor: "white", cursor: "pointer" }}
                  >
                    I understand this action cannot be undone.
                  </label>
                </div>
                <div className="delete-dial-btn-con">
                  <button
                    onClick={handleDeleteConfirm}
                    color="secondary"
                    variant="contained"
                    disabled={!isCheckboxChecked}
                    className="add-btn"
                    style={{
                      backgroundColor: isCheckboxChecked ? "red" : "gray",
                    }}
                  >
                    Delete
                  </button>

                  <button onClick={handleCloseDial} className="cancel-btn">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {isConvertDialogOpen && selectedEstimateDetails && (
        <ConvertToProject
          estimateDetails={selectedEstimateDetails}
          goBack={() => setIsConvertDialogOpen(false)}
          loading={loading} // Pass loading as a prop
          setLoading={setLoading} // Pass setLoading as a prop if needed
        />
      )}
    </>
  );
};
